export default {
  data () {
    return {
      cbId: '',
    }
  },
  created () {
    this.cbId = Math.random().toString(16).slice(2)
  },
}



// WEBPACK FOOTER //
// ./src/mixins/cd-id.js